var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import Basic from './basic';
import { StyleType1a, StyleType1b, StyleType2a, StyleType2b, StyleType3a, StyleType3b, StyleType4a, StyleType4b, } from './styleTypes';
var WrapperStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  color: ", ";\n\n  ", "\n\n  ", "\n    \n  ", "\n    \n  ", "\n  \n  ", "\n  @media only screen and (min-width: ", ") {\n    ", "\n  }\n  @media only screen and (min-width: ", ") {\n    ", ";\n  }\n\n  .headline {\n    text-rendering: optimizeLegibility;\n    ", "\n  }\n\n  .sub-headline {\n    text-rendering: optimizeLegibility;\n    margin-top: 0.5rem;\n    display: none;\n    ", "\n\n    @media only screen and (min-width: ", ") {\n      display: block;\n    }\n  }\n\n  ", ";\n\n  ", ";\n\n  .icon-arrow-right {\n    position: absolute;\n    bottom: 1rem;\n    right: 1rem;\n    width: 1.15rem;\n    height: 1.15rem;\n\n    fill: ", ";\n  }\n"], ["\n  ", "\n\n  color: ",
    ";\n\n  ",
    "\n\n  ", "\n    \n  ", "\n    \n  ", "\n  \n  ", "\n  @media only screen and (min-width: ", ") {\n    ", "\n  }\n  @media only screen and (min-width: ", ") {\n    ",
    ";\n  }\n\n  .headline {\n    text-rendering: optimizeLegibility;\n    ", "\n  }\n\n  .sub-headline {\n    text-rendering: optimizeLegibility;\n    margin-top: 0.5rem;\n    display: none;\n    ", "\n\n    @media only screen and (min-width: ", ") {\n      display: block;\n    }\n  }\n\n  ",
    ";\n\n  ",
    ";\n\n  .icon-arrow-right {\n    position: absolute;\n    bottom: 1rem;\n    right: 1rem;\n    width: 1.15rem;\n    height: 1.15rem;\n\n    fill: ",
    ";\n  }\n"])), Basic, function (_a) {
    var component = _a.theme.component, styleIsNegativeTextColor = _a.styleIsNegativeTextColor;
    return styleIsNegativeTextColor
        ? component.flexibleTeaser.default.wrapper.fontColorNegative
        : component.flexibleTeaser.default.wrapper.fontColor;
}, function (_a) {
    var component = _a.theme.component, styleBorderColor = _a.styleBorderColor;
    return "border: " + component.flexibleTeaser.default.wrapper.borderSize + " solid " + styleBorderColor + ";";
}, function (_a) {
    var styleBackgroundColor = _a.styleBackgroundColor;
    return "background-color: " + styleBackgroundColor + ";";
}, function (_a) {
    var styleAlignment = _a.styleAlignment;
    return "justify-content: " + styleAlignment + ";";
}, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    return "align-content: " + styleVerticalAlignment + ";";
}, function (_a) {
    var styleScalingFactorMob = _a.styleScalingFactorMob;
    return "transform: scale(" + styleScalingFactorMob + ");";
}, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var styleScalingFactorTab = _a.styleScalingFactorTab;
    return "transform: scale(" + styleScalingFactorTab + ");";
}, function (_a) {
    var desktopMinWidth = _a.desktopMinWidth;
    return desktopMinWidth;
}, function (_a) {
    var styleScalingFactor = _a.styleScalingFactor;
    if (styleScalingFactor === 1) {
        return 'transform: none';
    }
    return "transform: scale(" + styleScalingFactor + ");";
}, function (_a) {
    var styleFont = _a.styleFont;
    return styleFont && "font-family: " + styleFont + ";";
}, function (_a) {
    var styleFontSubHeadline = _a.styleFontSubHeadline;
    return styleFontSubHeadline && "font-family: " + styleFontSubHeadline + ";";
}, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var styleType = _a.styleType;
    switch (styleType) {
        case '1a':
            return StyleType1a;
        case '1b':
            return StyleType1b;
        case '2a':
            return StyleType2a;
        case '2b':
            return StyleType2b;
        case '3a':
            return StyleType3a;
        case '3b':
            return StyleType3b;
        case '4a':
            return StyleType4a;
        case '4b':
            return StyleType4b;
        default:
            return StyleType3a;
    }
}, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    switch (styleVerticalAlignment) {
        case 'top':
            return 'top: 11%;';
        case 'bottom':
            return 'bottom: 11%;';
        default:
            return null;
    }
}, function (_a) {
    var component = _a.theme.component, styleIsNegativeTextColor = _a.styleIsNegativeTextColor;
    return styleIsNegativeTextColor
        ? component.flexibleTeaser.default.wrapper.fontColorNegative
        : component.flexibleTeaser.default.wrapper.fontColor;
});
export var WrapperAnchor = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), WrapperStyle);
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), WrapperStyle);
export default Wrapper;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map